import { Link } from "react-router-dom";
import { AMENITY_LABELS } from "@/lib/api";
import { toDisplayUrl } from "@/components/PhotoUpload";
import { StarBadge } from "@/components/Stars";
import { MapPin } from "@phosphor-icons/react";

export default function ListingCard({ listing, index = 0 }) {
  return (
    <Link
      to={`/listings/${listing.id}`}
      data-testid={`listing-card-${listing.id}`}
      className="group block border border-neutral-200 hover:border-neutral-400 transition-colors bg-white rounded-md overflow-hidden fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="aspect-[4/3] overflow-hidden bg-neutral-100">
        <img
          src={toDisplayUrl(listing.photos?.[0])}
          alt={listing.title}
          className="w-full h-full object-cover group-hover:scale-105"
          style={{ transition: "transform 0.5s ease-out" }}
        />
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <h3 className="font-display font-medium text-[17px] leading-snug tracking-tight truncate">{listing.title}</h3>
            <div className="mt-1 flex items-center gap-2 text-xs text-neutral-500">
              <MapPin size={12} weight="regular"/> {listing.neighborhood}
              <span className="text-neutral-300">·</span>
              <StarBadge rating={listing.avg_rating} count={listing.review_count} size={11}/>
            </div>
          </div>
          <div className="text-right shrink-0">
            <div className="font-display font-semibold text-lg leading-none">${listing.hourly_rate}</div>
            <div className="text-[10px] tracking-widest uppercase text-neutral-500 mt-0.5">/ hour</div>
          </div>
        </div>
        <div className="mt-4 flex flex-wrap gap-1.5">
          {listing.amenities?.slice(0, 3).map((a) => (
            <span key={a} className="text-[11px] px-2 py-0.5 border border-neutral-200 text-neutral-600 rounded-sm">
              {AMENITY_LABELS[a] || a}
            </span>
          ))}
          {listing.amenities?.length > 3 && (
            <span className="text-[11px] px-2 py-0.5 text-neutral-500">+{listing.amenities.length - 3}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
